export const tabType = {
    CHANGE_CARD_VIEW: "CHANGE_CARD_VIEW",


    POST_TAB_KEY: "POST_TAB_KEY",

    POST_TAB_COLUMNS: "POST_TAB_COLUMNS",

    POST_TAB_DATA_SOURCE: "POST_TAB_DATA_SOURCE",


}